import axios from 'axios';
import { watch } from 'vue'; // watch fonksiyonunu Vue'dan içe aktarıyoruz
import { useLocalStorage } from '@vueuse/core';

const token = useLocalStorage('token', ''); // Token'ı useLocalStorage ile alıyoruz


const axiosCustom = axios.create({
  baseURL: 'https://tfonfuar.gifadwork.com/api/app/',
  headers: {
    Authorization: `Bearer ${token.value}`,
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data'
  },
});

// Token değişikliklerini izlemek için bir watch ekliyoruz
watch(token, (newToken) => {
  axiosCustom.defaults.headers['Authorization'] = `Bearer ${newToken}`; // Template literal kullanıldı
});

export default axiosCustom;